import React, { Component } from "react";
// import moment from 'moment'
import { Box } from "reactjs-admin-lte";
import { Checkbox } from "react-icheck";
import "icheck/skins/all.css";
import {
  Modal,
  Alert,
  ButtonToolbar,
  Button,
  DropdownButton,
  MenuItem,
  Popover,
  OverlayTrigger,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
// import Select from 'react-select'
import XLSX from "xlsx";
import FileSaver from "file-saver";
import SlipEditPopup from "./SlipEditPopup";
import HolidayPopup from "./HolidayPopup";
import SlipConfigPopup from "./SlipConfigPopup";
import EmployeeAbsenceTablePopup from "../absence/EmployeeAbsenceTablePopup";
import EmployeeDeductionTablePopup from "../deduction/EmployeeDeductionTablePopup";
import AlertPopup from "../../../component/element/AlertPopup";
// import AlertPopupStore from '../../../component/element/AlertPopupStore'
import CkSlipPeriod from "../../../component/element/CkSlipPeriod";
import HrStore from "../../../stores/HrStore";
// import { randomBytes } from 'crypto';
import SlipTableHiddenFieldModal from "./SlipTableHiddenFieldModal";
// import withSizes from 'react-sizes';
import ReportMobileTable from "../../report/ReportMobileTable";
import IframeModal from "component/element/IframeModal";
import { connect } from "react-redux";
import ConfirmPopup from "component/element/ConfirmPopup";

var NotificationSystem = require("react-notification-system");

const localStorageKey = "kkc.slipDailyEmployeeTable";
const localStorageKey2 = "kkc.slipMonthlyEmployeeTable";
const localStorageKeyM = "kkc.slipMonthlyEmployeeTable.hiddenField";
const localStorageKeyD = "kkc.slipDailyEmployeeTable.hiddenField";

//import SlipExcelExporter from './SlipExcelExporter'
//http://adazzle.github.io/react-data-grid/examples.html#/sortable-cols
// const TOTAL_DAYS = 13
const NUMBER_FIELD = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
const EDIT_FIELD = [5, 6, 7, 8, 9, 10, 11, 12];

const SLIP_INDEX = 0;
const EM_ID_INDEX = 1;
const EM_NAME_INDEX = 2;

const COUNT_OFFICE_INDEX = 5;
const WAGE_FIELD_INDEX = 6;
const TOTAL_WAGE_INDEX = 7;
const DRAWING_INDEX = 8;
const OT_HOUR_INDEX = 9;
const OT_WEEKEND_INDEX = 10;
const OT_AMOUNT_AFTERWORK_INDEX = 11;
const OT_AMOUNT_WEEKEND_INDEX = 12;
const TOTAL_INCOME_INDEX = 13;
// const CUMULATIVE_DEPT_INDEX = 14
const SOCIAL_SECURITY_INDEX = 15;
const ABSENCE_DEDECTION_INDEX = 16;
// const TOTAL_DEDUCTION_INDEX = 17
const NET_INCOME_INDEX = 18;
const PAYABLE_INDEX = 19;

const DAILY_DISABLE_FIELDS = [
  TOTAL_WAGE_INDEX,
  TOTAL_INCOME_INDEX,
  NET_INCOME_INDEX,
];
const MONTHLY_DISABLE_FIELDS = [
  TOTAL_WAGE_INDEX,
  TOTAL_INCOME_INDEX,
  NET_INCOME_INDEX,
];
const SORT_COLUMN = [
  "slip_no",
  "employee_id",
  "name",
  "nick_name",
  "department",
];
const TABLE_LIST = [
  {
    id: "min_sso_wage",
    title: "ค่าจ้างต่อเดือนต่ำสุดที่ใช้ในการคำนวณ",
    value: "",
  },
  {
    id: "max_sso_wage",
    title: "ค่าจ้างสูงสุดที่ใช้ในการคำนวณ",
    value: "",
  },
  {
    id: "sso_ratio",
    title: "อัตราที่จ่ายประกันสังคม",
    value: "",
  },
];
class SlipDailyEmployeeTable extends Component {
  constructor(...args) {
    super(...args);
    this.slipConfig = {};

    this.pdfTemplate = {};
    let { emType } = this.props;

    let defaultSortDaily = JSON.parse(
      localStorage.getItem(localStorageKey)
    ) || { sortKey: "slip_no", sortDirection: "asc" };
    const defaultPercent = JSON.parse(
      localStorage.getItem(localStorageKey2)
    ) || { sortStatus: "", sortStatus2: "", sortStatus3: "" };
    let defaultHiddenField = [];

    if (emType === "daily") {
      defaultHiddenField =
        JSON.parse(localStorage.getItem(localStorageKeyD)) || [];
    } else {
      defaultHiddenField =
        JSON.parse(localStorage.getItem(localStorageKeyM)) || [];
    }
    defaultSortDaily = Object.assign(
      { sortkey: "slip_no", sortDirection: "asc" },
      defaultSortDaily
    );
    const { sortKey, sortDirection } = defaultSortDaily;
    this.state = {
      show: false,
      showPeriod: false,
      titleCreateSlip: "",
      msgCreateSlip: "",
      showCreateSlip: false,
      sortDirection: sortDirection,
      sortKey: sortKey,
      defaultPercent: defaultPercent,
      showHoliday: false,
      showCfg: false,
      showPeriod: false,
      showSSO: false,
      showAbsenceForm: false,
      showDeductionForm: false,
      editRow: "",
      loading: true,
      statusText: "",
      slipId: "",
      tableList: [],
      hidden_key_field: [],
      hidden_key_field_print: [],
      table_key_field: {
        employee_info: [],
        income: [],
        deduction: [],
        other_info: [],
      },
      tList: TABLE_LIST,
      ssoCheckBox: false,
      table_key_name: {},
      slipPeriod: [],
      hrConfig: null,
      periodState: {},
      showHField: false,
      hiddenField: defaultHiddenField,
    };

    this.refTableId = "slipEmpTable-" + Math.ceil(Math.random() * 100);
    //this.loadNetworkData(year,month,option)
  }

  componentDidMount() {
    this.setState({ showPeriod: true });
  }

  onInitPeriod(periodState) {
    this.setState({ periodState: periodState });
    let { year, month, rangeValue } = periodState;
    let { emType } = this.props;
    //this.loadNetworkData(year,month,rangeValue)

    HrStore.loadSlipConfigPeriodParams(
      { year: year, month: month, em_type: emType },
      (result) => {
        this.slipConfig = result.data;
        this.pdfTemplate = result.pdf_template;
        //console.log('slipConfig',that.slipConfig,that.hrConfig)
        this.setState({
          hrConfig: result.hr_config,
          slipPeriod: result.slip_period,
        });
        //resolve({that:that,newOption:newOption})
      },
      (error) => {}
    );
  }

  loadNetworkData(year, month, option) {
    let { emType } = this.props;
    let loadConfig = (that) => {
      let promise = new Promise((resolve, reject) => {
        HrStore.loadSlipConfigPeriodParams(
          { year: year, month: month, em_type: emType },
          (result) => {
            this.slipConfig = result.data;
            this.pdfTemplate = result.pdf_template;
            //console.log('slipConfig',that.slipConfig,that.hrConfig)
            this.setState({
              hrConfig: result.hr_config,
              slipPeriod: result.slip_period,
            });
            //resolve({that:that,newOption:newOption})
          },
          (error) => {
            reject(error);
          }
        );
      });
      return promise;
    };

    let loadAllSlipDailyWage = (self) => {
      let promise = new Promise((resolve, reject) => {
        //self.that.loadAllSlipWage(emType,year,month,self.newOption,reject)
      });
      return promise;
    };

    loadConfig(this)
      .then(loadAllSlipDailyWage)
      .catch((error) => {
        // console.log('error:',error)
        this.setState({ loading: false, statusText: error.desc });
      });
  }

  loadAllSlipWage(emType, year, month, option, reject) {
    if (emType === "daily") {
      option.resulttype = "keyvalue";
      HrStore.loadAllSlipDailyWage(
        year,
        month,
        option,
        (result) => {
          this.setState({
            loading: false,
            tableList: this.getDataSort(result.data),
            hidden_key_field: result.hidden_key_field,
            hidden_key_field_print: result.hidden_key_field_print,
            table_key_field: result.table_key_field,
            table_key_name: result.table_key_name,
          }); //tableList:result.data,
          //this.getDataSort(result.data)
        },
        function (error) {
          if (typeof reject !== "undefined") reject(error);
        }
      );
    } else {
      option.resulttype = "keyvalue";
      HrStore.loadAllSlipMonthlyWage(
        year,
        month,
        option,
        (result) => {
          //this.getDataSort(result.data)
          this.setState({
            loading: false,
            tableList: this.getDataSort(result.data),
            hidden_key_field: result.hidden_key_field,
            hidden_key_field_print: result.hidden_key_field_print,
            table_key_field: result.table_key_field,
            table_key_name: result.table_key_name,
          }); //tableList:result.data,
        },
        function (error) {
          if (typeof reject !== "undefined") reject(error);
        }
      );
    }
  }

  loadSsoConfig() {
    let that = this;
    HrStore.loadSsoConfig(
      function (result) {
        let tList = TABLE_LIST.map((item, index) => {
          item.value = result.data[item.id];
          return item;
        });
        that.setState({
          ssoCheckBox: result.data.apply_all_employee,
          tList: tList,
          loading: false,
        });
      },
      function () {}
    );
  }

  getDataSort(data) {
    let { emType } = this.props;
    let { sortKey, sortDirection } = this.state;

    let key = sortKey;

    if (sortDirection === "desc") {
      data.reverse(function (a, b) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
    } else if (sortDirection === "asc") {
      data.sort(function (a, b) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
    }

    //this.setState({tableList:data})
    return data;
  }

  onValueChange(index, e) {
    let { tList } = this.state;
    tList[index].value = e.target.value;
    this.setState({ tList: tList });
  }

  onSortClick(key, e) {
    let { emType } = this.props;
    let {
      tableList,
      defaultPercent,
      defaultSortDaily,
      sortDirection,
      sortKey,
    } = this.state;
    if (!SORT_COLUMN.includes(key)) {
      return;
    }
    if (tableList !== undefined && tableList.length > 1) {
      let defaultSort = defaultPercent;
      let localKey = localStorageKey2;
      if (emType === "daily") {
        defaultSort = defaultSortDaily;
        localKey = localStorageKey;
      }
      sortDirection = sortDirection === "asc" ? "desc" : "asc";

      if (sortDirection === "asc") {
        tableList.sort(function (a, b) {
          if (a[key] < b[key]) return -1;
          if (a[key] > b[key]) return 1;
          return 0;
        });
      } else {
        tableList.reverse(function (a, b) {
          if (a[key] < b[key]) return -1;
          if (a[key] > b[key]) return 1;
          return 0;
        });
      }

      let config = { sortKey: key, sortDirection: sortDirection };
      localStorage.setItem(localKey, JSON.stringify(config));
      this.setState({
        tableList: tableList,
        sortKey: key,
        sortDirection: sortDirection,
      });
    }
  }

  onSortClick2(key, e) {
    let { emType } = this.props;
    let { tableList, defaultPercent, defaultSortDaily } = this.state;
    if (tableList !== undefined && tableList.length > 1) {
      let defaultSort = defaultPercent;
      let localKey = localStorageKey2;
      if (emType === "daily") {
        defaultSort = defaultSortDaily;
        localKey = localStorageKey;
      }

      if (key === "slip") {
        if (
          defaultSort.sortStatus === "" ||
          defaultSort.sortStatus === "desc"
        ) {
          defaultSort.sortStatus = "asc";
          tableList.sort(function (a, b) {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
          });
        } else if (defaultSort.sortStatus === "asc") {
          defaultSort.sortStatus = "desc";
          tableList.reverse(function (a, b) {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
          });
        }
        defaultSort.sortStatus2 = "";
        defaultSort.sortStatus3 = "";
      } else if (key === "code") {
        if (
          defaultSort.sortStatus2 === "" ||
          defaultSort.sortStatus2 === "desc"
        ) {
          defaultSort.sortStatus2 = "asc";
          tableList.sort(function (a, b) {
            if (a[1] < b[1]) return -1;
            if (a[1] > b[1]) return 1;
            return 0;
          });
        } else if (defaultSort.sortStatus2 === "asc") {
          defaultSort.sortStatus2 = "desc";
          tableList.reverse(function (a, b) {
            if (a[1] < b[1]) return -1;
            if (a[1] > b[1]) return 1;
            return 0;
          });
        }
        defaultSort.sortStatus = "";
        defaultSort.sortStatus3 = "";
      } else if (key === "name") {
        if (
          defaultSort.sortStatus3 === "" ||
          defaultSort.sortStatus3 === "desc"
        ) {
          defaultSort.sortStatus3 = "asc";
          tableList.sort(function (a, b) {
            if (a[2] < b[2]) return -1;
            if (a[2] > b[2]) return 1;
            return 0;
          });
        } else if (defaultSort.sortStatus3 === "asc") {
          defaultSort.sortStatus3 = "desc";
          tableList.reverse(function (a, b) {
            if (a[2] < b[2]) return -1;
            if (a[2] > b[2]) return 1;
            return 0;
          });
        }
        defaultSort.sortStatus = "";
        defaultSort.sortStatus2 = "";
      }
      let config = {
        sortStatus: defaultSort.sortStatus,
        sortStatus2: defaultSort.sortStatus2,
        sortStatus3: defaultSort.sortStatus3,
      };
      localStorage.setItem(localKey, JSON.stringify(config));
      this.setState({ tableList: tableList });
    }
  }

  onCreateSlipConfirm() {
    let { emType } = this.props;
    let that = this;
    let { periodState } = this.state;
    let { year, month, rangeValue, options } = periodState;
    that.setState({ loading: true });
    if (emType === "daily") {
      HrStore.newSlipDailyWage(
        year,
        month,
        rangeValue,
        options,
        function (result) {
          that.setState({
            loading: false,
            tableList: result.data,
            showCreateSlip: false,
          });
        },
        function (error) {
          // console.log('error',error)
        }
      );
    } else {
      HrStore.newSlipMonthlyWage(
        year,
        month,
        rangeValue,
        options,
        function (result) {
          that.setState({
            loading: false,
            tableList: result.data,
            showCreateSlip: false,
          });
        },
        function (error) {
          // console.log('error',error)
        }
      );
    }
  }

  onCreateSlipClick() {
    let that = this;
    let { tableList } = this.state;
    // let {year,month,rangeValue,options} = this.state.periodState
    let { emType, messages } = this.props;

    let title = messages["Create Slip Sub Contract Daily"];
    if (emType === "monthly") {
      title = messages["Create Slip Full Time"];
    }
    if (tableList.length > 0) {
      title = messages["Already Slip"];
    }
    that.setState({
      showCreateSlip: true,
      titleCreateSlip: messages["Confirm"],
      msgCreateSlip: title,
    });
    // AlertPopupStore.confirm(title,messages['Confirm'],function(){
    //   that.setState({loading:true})
    //   if(emType==='daily'){
    //     HrStore.newSlipDailyWage(year,month,rangeValue,options,function(result){
    //       that.setState({loading:false,tableList:result.data})
    //     },function(error){
    //       // console.log('error',error)
    //     })
    //   }else{
    //     HrStore.newSlipMonthlyWage(year,month,rangeValue,options,function(result){
    //       that.setState({loading:false,tableList:result.data})
    //     },function(error){
    //       // console.log('error',error)
    //     })
    //   }
    // })
  }

  onRowClick(slipId) {
    // console.log('onRowClick',slipId)
    //this.refs.slipEditPopup.loadSlipInfo(slipId);
    this.setState({ show: true, slipId: slipId });
  }

  onColumnClickIndex(row, col, colValue) {
    // console.log('row',row,col)
    let { emType } = this.props;
    let { tableList, periodState } = this.state;
    let { year, month, rangeValue } = periodState;
    let disableFields = [];
    disableFields = DAILY_DISABLE_FIELDS;
    if (emType === "monthly") {
      disableFields = [];
      disableFields = disableFields.concat(MONTHLY_DISABLE_FIELDS);
      if (rangeValue.seqInMonth === "secondhalf")
        disableFields.push(DRAWING_INDEX);
    }

    if (EDIT_FIELD.includes(col) && !disableFields.includes(col)) {
      let value =
        typeof colValue.value !== "undefined" ? colValue.value : colValue;
      tableList[row][col] = { value: value };

      this.setState({ tableList: tableList });
    } else if (col === SLIP_INDEX) {
      let slipId = tableList[row][SLIP_INDEX];
      //this.refs.slipEditPopup.loadSlipInfo(slipId);
      this.setState({ show: true, slipId: slipId, editRow: row });
    } else if (col === EM_ID_INDEX) {
      let emId = tableList[row][EM_ID_INDEX];
      this.onEmployeeIdClick(emId);
    } else if (col === EM_NAME_INDEX) {
      let emId = tableList[row][EM_ID_INDEX];
      this.onEmployeeIdClick(emId);
    } else if (col === SOCIAL_SECURITY_INDEX) {
      //this.refs.deductionPopup.loadDeduction(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      //this.setState({showDeductionForm:true,editRow:row})
    } else if (col === ABSENCE_DEDECTION_INDEX) {
      // this.refs.absencePopup.loadAbsence(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      // this.setState({showAbsenceForm:true,editRow:row})
    }
  }

  onColumnClick(row, col, colValue) {
    // console.log('row',row,col)
    let { emType } = this.props;
    let { tableList, periodState, table_key_field } = this.state;
    let { rangeValue } = periodState;
    let disableFields = [];
    disableFields = DAILY_DISABLE_FIELDS;
    if (emType === "monthly") {
      disableFields = [];
      disableFields = disableFields.concat(MONTHLY_DISABLE_FIELDS);
      if (rangeValue.seqInMonth === "secondhalf")
        disableFields.push(DRAWING_INDEX);
    }

    if (
      table_key_field.income.includes(col) ||
      table_key_field.deduction.includes(col)
    ) {
      let value =
        typeof colValue.value !== "undefined" ? colValue.value : colValue;
      tableList[row][col] = { value: value };

      this.setState({ tableList: tableList });
    } else if (col === "slip_no") {
      let slipId = tableList[row]["slip_no"];
      //this.refs.slipEditPopup.loadSlipInfo(slipId);
      this.setState({ show: true, slipId: slipId, editRow: row });
    } else if (col === "employee_id") {
      let emId = tableList[row]["employee_id"];
      this.onEmployeeIdClick(emId);
    } else if (col === "name") {
      let emId = tableList[row]["employee_id"];
      this.onEmployeeIdClick(emId);
    } else if (col === SOCIAL_SECURITY_INDEX) {
      //this.refs.deductionPopup.loadDeduction(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      //this.setState({showDeductionForm:true,editRow:row})
    } else if (col === ABSENCE_DEDECTION_INDEX) {
      // this.refs.absencePopup.loadAbsence(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      // this.setState({showAbsenceForm:true,editRow:row})
    }
  }

  getCountOfWorkOptions2() {
    let options = [];
    for (let i = 10; i < 31; i++) {
      options.push({ label: i + " " + this.props.messages["Day"], value: i });
    }
    return options;
  }

  getMonthText(month) {
    let result = "";
    this.getMonthOptions().map((item, index) => {
      if (item.value * 1 === month * 1) {
        result = item.label;
      }
      return item;
    });
    return result;
  }

  getWeekDay(year, month, day) {
    let myDate = new Date();
    myDate.setFullYear(year - 543);
    myDate.setMonth(month * 1 - 1);
    myDate.setDate(day);
    return myDate.getDay();
  }

  getCountOfWorkOptions() {
    let { year, month } = this.state;
    return this.getWeekDayOnMonth(year, month);
  }

  calculateIncome(row) {
    // console.log('cal',row)
    let { emType } = this.props;
    let { rangeValue } = this.state.periodState;
    if (emType === "daily") {
      row["total_wage"] = row["count_office_work"] * row["daily_wage"];
      row["ot_amount_afterwork"] = Math.round(
        (row["daily_wage"] / 8) *
          row["ot_hour_afterwork"] *
          this.slipConfig["OT_AFTERWORK_FOR_DAILY"]
      );
      row["ot_amount_weekend"] = Math.round(
        row["daily_wage"] *
          row["ot_hour_weekend"] *
          this.slipConfig["OT_HOLIDAY_FOR_DAILY"]
      );
    } else {
      row["ot_amount_afterwork"] = Math.round(
        (row[WAGE_FIELD_INDEX] / 30 / 8) *
          row["ot_hour_afterwork"] *
          this.slipConfig["OT_AFTERWORK_FOR_MONTHLY"]
      );
      row["ot_amount_weekend"] = Math.round(
        (row[WAGE_FIELD_INDEX] / 30) *
          row["ot_hour_weekend"] *
          this.slipConfig["OT_HOLIDAY_FOR_MONTHLY"]
      );
    }
    row["total_income"] =
      row["drawing_money"] * 1 +
      row["ot_amount_afterwork"] * 1 +
      row["ot_amount_weekend"] * 1;
    row["net_income"] = row["total_income"] * 1 - row["total_deduction"] * 1;

    if (emType === "monthly") {
      if (rangeValue.seqInMonth === "firsthalf")
        row["net_payable"] =
          row[WAGE_FIELD_INDEX] * 1 - row["drawing_money"] * 1;
    } else if (emType === "daily") {
      row["drawing_money"] = row["total_wage"];
    }

    return row;
  }

  validateValue(tableList, row, col, value) {
    let { emType, messages } = this.props;
    if (emType === "monthly") {
      if (col === DRAWING_INDEX) {
        let salary = tableList[row][WAGE_FIELD_INDEX];
        if (value > salary / 2) {
          //Alert
          // AlertPopupStore.confirm(messages['Withdrawal']+" "+value+" "+messages['More Than Half']+" "+salary,messages['Edit Info'],function(){

          // })
          this.setState({
            showCreateSlip: true,
            titleCreateSlip: messages["Edit Info"],
            msgCreateSlip:
              messages["Withdrawal"] +
              " " +
              value +
              " " +
              messages["More Than Half"] +
              " " +
              salary,
          });
          return false;
        }
      }
    }
    return true;
  }

  onInputBlur(row, col, colValue) {
    // console.log('onBlur',row,col,colValue)
    let { tableList, periodState, table_key_field } = this.state;
    let { year, month, options, rangeValue } = periodState;
    let { emType } = this.props;
    if (!this.validateValue(tableList, row, col, colValue.value)) {
      return;
    }
    tableList[row][col] = colValue.value;
    tableList[row] = this.calculateIncome(tableList[row]);
    this.setState({ tableList: tableList, loading: true });
    // console.log('tableList',tableList)
    let field_type = "normal";
    if (table_key_field.income.includes(col)) {
      field_type = "income";
    } else if (table_key_field.deduction.includes(col)) {
      field_type = "deduction";
    }
    let param = {
      em: tableList[row]["employee_id"],
      first_start_date: options[0].startDate,
      start_date: rangeValue.startDate,
      end_date: rangeValue.endDate,
      slip_per_month: options.length,
      field_type: field_type,
      periodic: HrStore.getPeriodic(year, month, rangeValue.value),
      em_type: emType,
      seq_in_month: rangeValue.seqInMonth,
    };
    if (col === "ot_hour_afterwork") {
      param = Object.assign(param, {
        field: "ot_hour",
        ot_type: 0,
        ot_hour: tableList[row][col],
        ot_amount: tableList[row]["ot_amount_afterwork"],
      });
    } else if (col === "ot_hour_weekend") {
      param = Object.assign(param, {
        field: "ot_hour",
        ot_type: 2,
        ot_hour: tableList[row][col],
        ot_amount: tableList[row]["ot_amount_weekend"],
      });
    } else if (col === "daily_wage" || col === "count_office_work") {
      param = Object.assign(param, {
        field: "wage_hour",
        end_date: rangeValue.endDate,
        count_office_work: tableList[row]["count_office_work"],
        wage_amount: tableList[row]["daily_wage"],
      });
    } else if (col === "drawing_money") {
      param = Object.assign(param, {
        field: "salary",
        drawing_money: tableList[row]["drawing_money"],
        total_income: tableList[row]["total_income"],
        net_payable: tableList[row]["net_payable"],
        net_income: tableList[row]["net_income"],
      });
    } else {
      param = Object.assign(param, {
        field: col,
        field_value: tableList[row][col],
      });
    }

    let sumList = this.sumTableObj(tableList);
    param["sum_table"] = sumList;

    HrStore.editSlipDailyWage(
      param,
      (result) => {
        this.setState({ loading: false });
        this.onEditPopup();
      },
      (error) => {
        // console.log('error',error);
        let statusText =
          error.desc !== undefined && error.desc.response !== undefined
            ? error.desc.response.data
            : this.props.messages["Error Admin"];
        this.setState({ loading: false, statusText: statusText });
      }
    );
  }

  onInputBlurIndex(row, col, colValue) {
    // console.log('onBlur',colValue)
    let { tableList, periodState } = this.state;
    let { year, month, rangeValue } = periodState;
    let { emType } = this.props;
    if (!this.validateValue(tableList, row, col, colValue.value)) {
      return;
    }
    tableList[row][col] = colValue.value;
    tableList[row] = this.calculateIncome(tableList[row]);
    this.setState({ tableList: tableList, loading: true });
    // console.log('tableList',tableList)
    let param = {
      em: tableList[row][EM_ID_INDEX],
      periodic: HrStore.getPeriodic(year, month, rangeValue.value),
      em_type: emType,
      seq_in_month: rangeValue.seqInMonth,
    };
    if (col === OT_HOUR_INDEX) {
      param = Object.assign(param, {
        field: "ot_hour",
        ot_type: 0,
        ot_hour: tableList[row][col],
        ot_amount: tableList[row][OT_AMOUNT_AFTERWORK_INDEX],
      });
    } else if (col === OT_WEEKEND_INDEX) {
      param = Object.assign(param, {
        field: "ot_hour",
        ot_type: 2,
        ot_hour: tableList[row][col],
        ot_amount: tableList[row][OT_AMOUNT_WEEKEND_INDEX],
      });
    } else if (col === WAGE_FIELD_INDEX) {
      param = Object.assign(param, {
        field: "wage_hour",
        end_date: rangeValue.endDate,
        count_office_work: tableList[row][COUNT_OFFICE_INDEX],
        wage_amount: tableList[row][col],
      });
    } else if (col === DRAWING_INDEX) {
      param = Object.assign(param, {
        field: "salary",
        drawing_money: tableList[row][DRAWING_INDEX],
        total_income: tableList[row][TOTAL_INCOME_INDEX],
        net_payable: tableList[row][PAYABLE_INDEX],
        net_income: tableList[row][NET_INCOME_INDEX],
      });
    } else if (col === COUNT_OFFICE_INDEX) {
      param = Object.assign(param, {
        field: "wage_hour",
        end_date: rangeValue.endDate,
        count_office_work: tableList[row][col],
        wage_amount: tableList[row][WAGE_FIELD_INDEX],
      });
    }

    //let sumList = this.sumTableObj(tableList)
    //param['sum_table'] = sumList;
    let that = this;
    HrStore.editSlipDailyWage(
      param,
      (result) => {
        this.setState({ loading: false });
        this.onEditPopup();
      },
      function (error) {
        // console.log('error',error);
        that.setState({ loading: false, statusText: error.desc.response.data });
      }
    );
  }

  onInputChange(row, col, e) {
    let value = e.target.value;
    let { tableList } = this.state;
    tableList[row][col] = e.target.value;
    tableList[row] = this.calculateIncome(tableList[row]);
    tableList[row][col] = { value: e.target.value };
    this.setState({ tableList: tableList });
  }

  onEmployeeIdClick(emId) {
    if (process.env.NODE_ENV == "development") {
      alert("click->" + emId);
    } else {
      window.show_employee_doc(emId);
    }
  }

  onSlipPrintClick(slipId) {
    if (this.pdfTemplate.PrintSalarySlipDoc !== undefined) {
      if (process.env.NODE_ENV == "development") {
        window.open(
          "./?startPage=" +
            this.pdfTemplate.PrintSalarySlipDoc +
            "&ss=" +
            slipId,
          "_blank"
        );
      } else {
        window.open(
          "./pdf/v2/?startPage=" +
            this.pdfTemplate.PrintSalarySlipDoc +
            "&ss=" +
            slipId,
          "_blank"
        );
      }
    } else {
      if (process.env.NODE_ENV == "development") {
        window.open(
          "https://demo2.bigfix.co/korat/pdf/?ss=" +
            slipId +
            "&file=salaryslip_doc",
          "_blank"
        );
      } else {
        window.open("./pdf/?ss=" + slipId + "&file=salaryslip_doc", "_blank");
      }
    }
  }

  onSlipPrintAllClick() {
    let { year, month, rangeValue } = this.state.periodState;
    let { emType } = this.props;
    let emId = emType === "monthly" ? 1 : 2;
    let periodic = HrStore.getPeriodic(year, month, rangeValue.value);

    if (this.pdfTemplate.PrintSalarySlipDoc !== undefined) {
      if (process.env.NODE_ENV == "development") {
        window.open(
          "./?startPage=" +
            this.pdfTemplate.PrintSalarySlipDoc +
            "&periodic=" +
            periodic +
            "&em_type=" +
            emId,
          "_blank"
        );
      } else {
        window.open(
          "./pdf/v2/?startPage=" +
            this.pdfTemplate.PrintSalarySlipDoc +
            "&periodic=" +
            periodic +
            "&em_type=" +
            emId,
          "_blank"
        );
      }
    } else {
      if (process.env.NODE_ENV == "development") {
        window.open(
          "https://demo2.bigfix.co/korat/pdf/?periodic=" +
            periodic +
            "&file=allslip_doc&em_type=" +
            emId,
          "_blank"
        );
      } else {
        window.open(
          "./pdf/?periodic=" + periodic + "&file=allslip_doc&em_type=" + emId,
          "_blank"
        );
      }
    }
  }

  onSlipPrintTableClick() {
    let { year, month, rangeValue } = this.state.periodState;
    // let periodic = HrStore.getPeriodic(year,month,rangeValue.value)
    let { emType } = this.props;
    // let emId = (emType==='monthly')?1:2;
    // let param = '&start_date='+rangeValue.startDate+'&end_date='+rangeValue.endDate
    let url = "";
    if (process.env.NODE_ENV == "development") {
      // window.open('https://demo2.bigfix.co/korat/pdf/?periodic=' + periodic + '&file=sliptable_doc&em_type='+emId+param, '_blank');
      url =
        "./?startPage=PrintSlipTableDoc&year=" +
        year +
        "&month=" +
        month +
        "&resulttype=" +
        rangeValue.resulttype +
        "&value=" +
        rangeValue.value +
        "&start=" +
        rangeValue.startDate +
        "&end=" +
        rangeValue.endDate +
        "&emType=" +
        emType;
    } else {
      // window.open('./pdf/?periodic=' + periodic + '&file=sliptable_doc&em_type='+emId+param, '_blank');
      url =
        "./pdf/v2/?startPage=PrintSlipTableDoc&year=" +
        year +
        "&month=" +
        month +
        "&resulttype=" +
        rangeValue.resulttype +
        "&value=" +
        rangeValue.value +
        "&start=" +
        rangeValue.startDate +
        "&end=" +
        rangeValue.endDate +
        "&emType=" +
        emType;
    }
    this.refs.iframe.loadUrl(url);
  }

  onSlipExportExcellClick() {
    let { messages } = this.props;
    // let {year,month} = this.state
    // var d = new Date(year, month*1, 0);
    // var day = d.getDate();
    // let periodic = day+'/'+month+'/'+year;

    // var url = API_MAIN + "/employee/allslip_dailywage?format=excel&periodic=" + periodic;
    // window.open(url, '_blank');

    const worksheet = XLSX.utils.table_to_book(
      document.getElementById(this.refTableId)
    );
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const title =
      this.props.emType === "monthly"
        ? messages["Employee Payroll Report"]
        : messages["Daily Wage Report"];

    const fileName = title + "ประจำวันที่ " + this.getRangeText() + ".xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
  }

  onEditPopup() {
    this.setState({ show: false, editRow: "" });
    let { emType } = this.props;
    let { year, month, rangeValue } = this.state.periodState,
      that = this;

    this.loadAllSlipWage(emType, year, month, rangeValue);
  }

  onEnter(row, col) {
    //Test
  }

  onMenuSelect(eventKey) {
    if (eventKey === 2) {
      this.setState({ showHoliday: true });
      this.refs.holidayPopup.loadHoliday();
    } else if (eventKey === 1) {
      this.setState({ showCfg: true });
      this.refs.slipCfgPopup.loadConfig();
    } else if (eventKey === 3) {
      this.setState({ showHField: true });
    } else if (eventKey === 4) {
      this.loadSsoConfig();
      this.setState({ showSSO: true });
    }
  }

  onHolidayClick() {
    this.setState({ showHoliday: true });
  }

  onAbsenceClose(changeFlag, profile, afterCloseFunc) {
    let { emType } = this.props;
    let { editRow, tableList, periodState } = this.state;
    let { year, month, options, rangeValue } = periodState;
    this.setState({ showAbsenceForm: false, loading: changeFlag });

    //Update Deduction

    if (changeFlag) {
      let sumList = this.sumTableObj(tableList);

      let param = {
        field: "absence",
        em_type: emType,
        em: tableList[editRow]["employee_id"],
        first_start_date: options[0].startDate,
        start_date: rangeValue.startDate,
        end_date: rangeValue.endDate,
        periodic: HrStore.getPeriodic(year, month, rangeValue.value),
        seq_in_month: rangeValue.seqInMonth,
        sum_table: sumList,
        slip_per_month: options.length,
      };
      if (profile !== undefined && profile.slip_per_month !== undefined) {
        param["slip_per_month"] = profile.slip_per_month;
      }

      HrStore.editSlipDailyWage(
        param,
        () => {
          this.setState({ loading: false });
          if (afterCloseFunc !== undefined) {
            afterCloseFunc();
          }
          //that.loadAllSlipWage(emType,year,month,rangeValue)
        },
        (error) => {
          // console.log('error',error);
          this.setState({ loading: false, statusText: error.desc });
        }
      );
    }
  }

  onDeductionClose(changeFlag) {
    this.setState({
      showDeductionForm: false,
      editRow: "",
      loading: changeFlag,
    });
  }

  onSlipEditAbsenceClose(changeFlag, profile, afterCloseFunc) {
    this.onAbsenceClose(changeFlag, profile, afterCloseFunc);
  }

  onSlipEditAbsence(loadAbsence) {
    let { tableList, periodState, editRow } = this.state;
    // let {rangeValue,options,year,month} = periodState
    // console.log('editRow',editRow)

    loadAbsence(
      tableList[editRow]["employee_id"],
      periodState,
      this.getRangeText()
    );
  }

  onSlipPeriodChange(periodState) {
    this.setState({ periodState: periodState });
    let { emType } = this.props;
    let { year, month, rangeValue } = periodState;
    this.loadAllSlipWage(emType, year, month, rangeValue);
  }

  onPeriodEditClick() {
    this.setState({ showPeriod: true });
  }

  onHiddenFieldChange(item) {
    this.setState({
      hidden_key_field: item.table,
      hidden_key_field_print: item.print,
    });

    //const {emType} = this.props
    //const  localKey = (emType==='daily') ? localStorageKeyD:localStorageKeyM
    //localStorage.setItem(localKey, JSON.stringify(hiddenField))
  }

  onSelectPeriod(period) {
    let { year, month, options, rangeValue } = this.state.periodState;

    // console.log('rangeVal',rangeValue,period)

    let monthText = this.getMonthText(month);

    let dayArr = period.start_date.split("/");
    let startDay = dayArr[0] * 1;
    dayArr = period.end_date.split("/");
    let endDay = dayArr[0] * 1;

    if (rangeValue.seqInMonth === "firsthalf") {
      options[0] = this.getRangeOption(
        year,
        month,
        startDay,
        endDay,
        monthText,
        "firsthalf"
      );
      rangeValue = options[0];
    } else if (rangeValue.seqInMonth === "secondhalf") {
      options[1] = this.getRangeOption(
        year,
        month,
        startDay,
        endDay,
        monthText,
        "secondhalf"
      );
      rangeValue = options[1];
    }

    let periodic = HrStore.getPeriodic(year, month, rangeValue.value);
    HrStore.saveSlipPeriod(
      periodic,
      year,
      month,
      rangeValue,
      function () {},
      function () {}
    );

    this.setState({
      showPeriod: false,
      options: options,
      rangeValue: rangeValue,
    });
  }

  getRangeText() {
    let { periodState } = this.state;
    let { rangeValue, year } = periodState;

    let betweenTitle =
      rangeValue !== undefined ? rangeValue.label + " " + year : "";
    return betweenTitle;
  }

  renderOverlayContent(item) {
    return (
      <Popover id="popover-trigger-hover-focus" title="รายละเอียด">
        <strong>
          <FontAwesome name="info" /> กดคลิ๊กเพื่อแก้ไข
        </strong>
      </Popover>
    );
  }

  renderEditColumnIndex(item, rowIndex, index) {
    if (index === SLIP_INDEX || index === EM_ID_INDEX) {
      return <a>{item}</a>;
    }
    if (item !== null && item !== "" && typeof item.value !== "undefined")
      return (
        <input
          autoFocus
          style={{ width: "80px", display: "inline-block" }}
          className="form-control text-right"
          value={item.value}
          onBlur={this.onInputBlur.bind(this, rowIndex, index, item)}
          onChange={this.onInputChange.bind(this, rowIndex, index)}
        />
      );

    if (EDIT_FIELD.includes(index)) {
      return (
        <OverlayTrigger
          trigger={["hover", "focus"]}
          placement="bottom"
          onEnter={this.onEnter.bind(this, rowIndex, index)}
          overlay={this.renderOverlayContent(item)}
        >
          <div>{this.getNumber(item)}</div>
        </OverlayTrigger>
      );
    }
    return (
      <div
        className={
          index === TOTAL_INCOME_INDEX
            ? "text-green"
            : index === NET_INCOME_INDEX
            ? "text-red"
            : ""
        }
      >
        {this.getNumber(item)}
      </div>
    );
  }

  renderEditColumn(item, rowIndex, index) {
    const { table_key_field } = this.state;
    if (item !== null && item !== "" && typeof item.value !== "undefined")
      return (
        <input
          autoFocus
          style={{ width: "80px", display: "inline-block" }}
          className="form-control text-right"
          value={item.value}
          onBlur={this.onInputBlur.bind(this, rowIndex, index, item)}
          onChange={this.onInputChange.bind(this, rowIndex, index)}
        />
      );

    if (
      table_key_field.income.includes(index) ||
      table_key_field.deduction.includes(index)
    ) {
      return (
        <OverlayTrigger
          trigger={["hover", "focus"]}
          placement="bottom"
          onEnter={this.onEnter.bind(this, rowIndex, index)}
          overlay={this.renderOverlayContent(item)}
        >
          <div>{this.getNumber(item)}</div>
        </OverlayTrigger>
      );
    } else {
      return <div>{this.getNumber(item)}</div>;
    }
  }

  renderColumnIndex(coldata, rowIndex) {
    let { emType } = this.props;
    let { rangeValue } = this.state.periodState;
    let disableFields = DAILY_DISABLE_FIELDS;
    if (emType === "monthly") {
      disableFields = [];
      disableFields = disableFields.concat(MONTHLY_DISABLE_FIELDS);
      if (rangeValue.seqInMonth === "secondhalf") {
        disableFields.push(DRAWING_INDEX);
      }
    }
    return coldata.map((item, index) => (
      <td
        key={index}
        className={
          (NUMBER_FIELD.includes(index) ? "text-right" : "") +
          (disableFields.includes(index) ? " disabled" : "") +
          " " +
          this.getHiddenClass(index)
        }
        onClick={this.onColumnClick.bind(this, rowIndex, index, item)}
      >
        {this.renderEditColumn(item, rowIndex, index)}
      </td>
    ));
  }

  getTableData(item, key, rowIndex) {
    if (item[key] !== undefined) {
      return (
        <div onClick={this.onColumnClick.bind(this, rowIndex, key, item[key])}>
          {this.renderEditColumn(item[key], rowIndex, key)}
        </div>
      );
    } else {
      return "!Error";
    }
  }

  renderTableList() {
    let { tableList, table_key_field } = this.state;
    if (tableList.length > 0) {
      return tableList.map((item, rowIndex) => (
        <tr key={rowIndex}>
          <td className={"text-center " + this.getHiddenClass("slip_no")}>
            {this.getTableData(item, "slip_no", rowIndex)}
          </td>
          {table_key_field.employee_info.map((key, index) => {
            return (
              <td
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
              >
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          {table_key_field.income.map((key, index) => {
            return (
              <td
                key={index}
                className={"text-right " + this.getHiddenClass(key)}
              >
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          <td className="text-right">
            {this.getTableData(item, "total_income", rowIndex)}
          </td>
          {table_key_field.deduction.map((key, index) => {
            return (
              <td
                key={index}
                className={"text-right " + this.getHiddenClass(key)}
              >
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          <td
            className={"text-right " + this.getHiddenClass("total_deduction")}
          >
            {this.getTableData(item, "total_deduction", rowIndex)}
          </td>
          <td className={"text-right " + this.getHiddenClass("net_income")}>
            {this.getTableData(item, "net_income", rowIndex)}
          </td>
          <td className={"text-right " + this.getHiddenClass("net_payable")}>
            {this.getTableData(item, "net_payable", rowIndex)}
          </td>
          {table_key_field.other_info.map((key, index) => {
            return (
              <td
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
              >
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
        </tr>
      ));
    } else {
      let colSpan =
        this.getTotalColumn(table_key_field.employee_info) +
        this.getTotalColumn(table_key_field.income) +
        this.getTotalColumn(table_key_field.deduction) +
        this.getTotalColumn(table_key_field.other_info) +
        5;
      return (
        <tr>
          <td colSpan={colSpan}>{this.props.messages["No Data"]}</td>
        </tr>
      );
    }
  }

  renderExportTableList() {
    let { tableList, table_key_field } = this.state;
    if (tableList.length > 0) {
      return tableList.map((item, rowIndex) => (
        <tr key={rowIndex}>
          {this.getHiddenClass("slip_no") === "hide" ? (
            ""
          ) : (
            <td className={"text-center"}>
              {this.getTableData(item, "slip_no", rowIndex)}
            </td>
          )}
          {table_key_field.employee_info.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <td key={index} className={"text-center"}>
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          {table_key_field.income.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <td key={index} className={"text-right"}>
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          <td className="text-right">
            {this.getTableData(item, "total_income", rowIndex)}
          </td>
          {table_key_field.deduction.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <td key={index} className={"text-right"}>
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
          {this.getHiddenClass("total_deduction") === "hide" ? (
            ""
          ) : (
            <td className={"text-right"}>
              {this.getTableData(item, "total_deduction", rowIndex)}
            </td>
          )}
          {this.getHiddenClass("net_income") === "hide" ? (
            ""
          ) : (
            <td className={"text-right"}>
              {this.getTableData(item, "net_income", rowIndex)}
            </td>
          )}
          {this.getHiddenClass("net_payable") === "hide" ? (
            ""
          ) : (
            <td className={"text-right"}>
              {this.getTableData(item, "net_payable", rowIndex)}
            </td>
          )}
          {table_key_field.other_info.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <td key={index} className={"text-center"}>
                {this.getTableData(item, key, rowIndex)}
              </td>
            );
          })}
        </tr>
      ));
    } else {
      let colSpan =
        this.getTotalColumn(table_key_field.employee_info) +
        this.getTotalColumn(table_key_field.income) +
        this.getTotalColumn(table_key_field.deduction) +
        this.getTotalColumn(table_key_field.other_info) +
        5;
      return (
        <tr>
          <td colSpan={colSpan}>{this.props.messages["No Data"]}</td>
        </tr>
      );
    }
  }

  renderButtonColumn(item) {
    return (
      <td className="text-center no-padding">
        <Button
          bsStyle="link"
          onClick={this.onSlipEditClick.bind(this, item[0])}
        >
          <FontAwesome name="pencil" />
        </Button>
        <Button
          bsStyle="link"
          onClick={this.onSlipPrintClick.bind(this, item[0])}
        >
          <FontAwesome name="print" />
        </Button>
        <Button bsStyle="link">
          <FontAwesome name="user-o" />
        </Button>
      </td>
    );
  }

  getHiddenClass(key = "") {
    let { hidden_key_field } = this.state;
    if (hidden_key_field.includes(key)) {
      return "hide";
    } else {
      return "";
    }
  }

  getTableTitle(key) {
    const { table_key_name } = this.state;
    if (table_key_name[key] !== undefined) {
      return table_key_name[key];
    } else {
      return key;
    }
  }

  getTotalColumn(filedList) {
    let { hidden_key_field } = this.state;
    let list = filedList.reduce((rresult, item, index) => {
      if (hidden_key_field.includes(item)) {
      } else {
        rresult.push(item);
      }
      return rresult;
    }, []);
    return list.length;
  }

  renderSortDirection(key) {
    const { sortKey, sortDirection } = this.state;
    if (SORT_COLUMN.includes(key)) {
      let sortIcon = "sort";
      if (sortKey == key) {
        if (sortDirection == "asc") {
          sortIcon = "sort-asc";
        } else {
          sortIcon = "sort-desc";
        }
      }
      return (
        <span>
          &nbsp;
          <FontAwesome className={"pull-right"} name={sortIcon} />
        </span>
      );
    } else {
      return "";
    }
  }

  renderHeader() {
    let { messages } = this.props;
    let { table_key_field } = this.state;
    // let defaultSort = defaultPercent
    // if (emType==='daily') {
    //   defaultSort = defaultSortDaily
    // }
    // let hideIndex = 0
    let otherInfoColSpan = this.getTotalColumn(table_key_field.other_info);
    return (
      <thead>
        <tr>
          <th
            rowSpan="2"
            className={this.getHiddenClass("slip_no")}
            style={{ width: "80px" }}
            onClick={this.onSortClick.bind(this, "slip_no")}
          >
            {messages["Slip No"]}
            {this.renderSortDirection("slip_no")}
          </th>
          <th
            colSpan={this.getTotalColumn(table_key_field.employee_info)}
            className="text-center"
          >
            {messages["Employee Info"]}
          </th>
          <th
            colSpan={this.getTotalColumn(table_key_field.income)}
            className="text-center"
          >
            {messages["Income"]}
          </th>
          <th
            rowSpan="2"
            className={"bg-green " + this.getHiddenClass("total_income")}
          >
            {messages["Total Income"]}
          </th>
          <th
            colSpan={this.getTotalColumn(table_key_field.deduction)}
            className="text-center"
          >
            {messages["Deduction"]}
          </th>
          <th rowSpan="2" className={this.getHiddenClass("total_deduction")}>
            {messages["Total Deduction"]}
          </th>
          <th
            colSpan="2"
            className={"text-center " + this.getHiddenClass("net_payable")}
          >
            {messages["Net Payable"]}
          </th>
          <th
            colSpan={otherInfoColSpan}
            className={"text-center " + (otherInfoColSpan === 0 ? "hide" : "")}
          >
            {messages["Other Info"]}
          </th>
        </tr>
        <tr role="row">
          {table_key_field.employee_info.map((key, index) => {
            return (
              <th
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
                onClick={this.onSortClick.bind(this, key)}
              >
                {this.getTableTitle(key)}
                {this.renderSortDirection(key)}
              </th>
            );
          })}
          {table_key_field.income.map((key, index) => {
            return (
              <th
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
              >
                {this.getTableTitle(key)}
              </th>
            );
          })}
          {table_key_field.deduction.map((key, index) => {
            return (
              <th
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
              >
                {this.getTableTitle(key)}
              </th>
            );
          })}
          <th className={"bg-red " + this.getHiddenClass("net_income")}>
            {messages["Net Income"]}
          </th>
          <th className={this.getHiddenClass("net_payable")}>
            {messages["Net Payable Accrued"]}
          </th>
          {table_key_field.other_info.map((key, index) => {
            return (
              <th
                key={index}
                className={"text-center " + this.getHiddenClass(key)}
              >
                {this.getTableTitle(key)}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }

  renderExportHeader() {
    let { messages } = this.props;
    let { table_key_field } = this.state;
    let otherInfoColSpan = this.getTotalColumn(table_key_field.other_info);
    return (
      <thead>
        <tr>
          {this.getHiddenClass("slip_no") === "hide" ? (
            ""
          ) : (
            <th
              rowSpan="2"
              style={{ width: "80px" }}
              onClick={this.onSortClick.bind(this, "slip_no")}
            >
              {messages["Slip No"]}
              {this.renderSortDirection("slip_no")}
            </th>
          )}
          <th
            colSpan={this.getTotalColumn(table_key_field.employee_info)}
            className="text-center"
          >
            {messages["Employee Info"]}
          </th>
          <th
            colSpan={this.getTotalColumn(table_key_field.income)}
            className="text-center"
          >
            {messages["Income"]}
          </th>
          {this.getHiddenClass("total_income") === "hide" ? (
            ""
          ) : (
            <th rowSpan="2" className={"bg-green"}>
              {messages["Total Income"]}
            </th>
          )}
          <th
            colSpan={this.getTotalColumn(table_key_field.deduction)}
            className="text-center"
          >
            {messages["Deduction"]}
          </th>
          {this.getHiddenClass("total_deduction") === "hide" ? (
            ""
          ) : (
            <th rowSpan="2">{messages["Total Deduction"]}</th>
          )}
          {this.getHiddenClass("net_payable") === "hide" ? (
            ""
          ) : (
            <th colSpan="2" className={"text-center"}>
              {messages["Net Payable"]}
            </th>
          )}
          {otherInfoColSpan === 0 ? (
            ""
          ) : (
            <th
              colSpan={otherInfoColSpan}
              className={
                "text-center " + (otherInfoColSpan === 0 ? "hide" : "")
              }
            >
              {messages["Other Info"]}
            </th>
          )}
        </tr>
        <tr role="row">
          {table_key_field.employee_info.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <th
                key={index}
                className={"text-center"}
                onClick={this.onSortClick.bind(this, key)}
              >
                {this.getTableTitle(key)}
                {this.renderSortDirection(key)}
              </th>
            );
          })}
          {table_key_field.income.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <th key={index} className={"text-center"}>
                {this.getTableTitle(key)}
              </th>
            );
          })}
          {table_key_field.deduction.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <th key={index} className={"text-center"}>
                {this.getTableTitle(key)}
              </th>
            );
          })}
          {this.getHiddenClass("net_income") === "hide" ? (
            ""
          ) : (
            <th className={"bg-red"}>{messages["Net Income"]}</th>
          )}
          {this.getHiddenClass("net_payable") === "hide" ? (
            ""
          ) : (
            <th>{messages["Net Payable Accrued"]}</th>
          )}
          {table_key_field.other_info.map((key, index) => {
            return this.getHiddenClass(key) === "hide" ? (
              ""
            ) : (
              <th key={index} className={"text-center"}>
                {this.getTableTitle(key)}
              </th>
            );
          })}
        </tr>
      </thead>
    );
  }

  renderTableList2() {
    let { tableList } = this.state;
    if (tableList.length > 0) {
      return tableList.map((item, index) => (
        <tr key={index}>{this.renderColumn(item, index)}</tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan={23}>{this.props.messages["No Data"]}</td>
        </tr>
      );
    }
  }

  sumTable(tableList) {
    let sumList = {};
    if (tableList.length > 0) sumList = new Array(tableList[0].length).fill(0);
    tableList.map((item, index) => {
      Object.keys(item).map((key) => {
        if (!isNaN(item[key])) {
          if (sumList[key] === undefined) sumList[key] = 0;
          sumList[key] += item[key] * 1;
        }
      });
      return item;
    });

    return sumList;
  }

  sumTableObj(tableList) {
    //array('salary'=>"",'wage_amount'=>'','withdraw_amount'=>"","ot_hour"=>"","ot_sunday"=>"","ot_amount"=>'',"deduction_withdraw"=>"",'net_balance'=>'',"net_unpaid"=>"")
    let sumObj = {
      salary: 0,
      wage_amount: 0,
      withdraw_amount: 0,
      ot_hour: 0,
      ot_sunday: 0,
      ot_amount: 0,
      deduction_withdraw: 0,
      net_balance: 0,
      net_unpaid: 0,
    };
    if (tableList.length > 0)
      tableList.map((item, index) => {
        sumObj["salary"] += item["daily_wage"] * 1;
        sumObj["wage_amount"] += item["total_wage"] * 1;
        sumObj["withdraw_amount"] += item["drawing_money"] * 1;
        sumObj["ot_hour"] += item["ot_hour"] * 1;
        sumObj["ot_sunday"] += item["ot_hour_weekend"] * 1;
        sumObj["ot_amount"] += item["ot_amount_afterwork"] * 1;
        sumObj["ot_amount"] += item["ot_amount_weekend"] * 1;
        sumObj["deduction_withdraw"] += item["total_deduction"] * 1;
        sumObj["net_balance"] += item["net_income"] * 1;
        sumObj["net_unpaid"] += item["net_payable"] * 1;

        return item;
      });
    return sumObj;
  }

  getNumber(number) {
    if (!isNaN(number))
      return number.toLocaleString(undefined, { maximumFractionDigits: 2 });
    else return number;
  }

  getFooterData(sumList, key) {
    if (sumList[key] !== undefined) {
      return this.getNumber(sumList[key]);
    } else {
      return "!Error";
    }
  }

  onSSOModelShow() {
    //Load
  }

  onSSOSave() {
    let that = this;
    let ssoConfig = {};
    TABLE_LIST.map((item, index) => {
      ssoConfig[item.id] = item.value;
      return item;
    });
    ssoConfig.apply_all_employee = this.state.ssoCheckBox;
    HrStore.saveSsoConfig(
      ssoConfig,
      function (result) {
        if (result.status === "OK") {
          that.setState({ statusText: "บันทึกเรียบร้อย" });
          setTimeout(function () {
            that.setState({ statusText: "" });
          }, 3000);
        }
      },
      function () {}
    );
  }

  renderTableData() {
    let { tList } = this.state;
    return tList.map((item, index) => (
      <tr key={index} className="data-row">
        <td className="data-column ">
          <ControlLabel>{item.title}</ControlLabel>
        </td>
        <td className="data-column">
          <FormControl
            value={item.value}
            className="text-center"
            onChange={this.onValueChange.bind(this, index)}
          />
        </td>
      </tr>
    ));
  }

  renderSSOTableConfig() {
    return (
      <table className="table table-input-border-none table-bordered-solid table-hover dataTable">
        <thead>
          <tr>
            <th>รายการ</th>
            <th>รายละเอียด</th>
          </tr>
        </thead>
        <tbody>{this.renderTableData()}</tbody>
      </table>
    );
  }

  renderSSOModalConfig() {
    let { showSSO, loading, tList } = this.state;

    return (
      <div>
        <Modal
          show={showSSO}
          onShow={this.onSSOModelShow.bind(this)}
          enforceFocus={false}
          onHide={() => {
            this.setState({ showSSO: false });
          }}
          dialogClassName="smallwidth-dialog"
        >
          <Modal.Header closeButton>
            <Modal.Title>{"พนักงานและบริษัทอัตราเดียวกัน"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading ? (
              <div>กำลังดึงข้อมูล...</div>
            ) : (
              <div>
                {this.renderSSOTableConfig()}
                <Checkbox
                  onChange={() =>
                    this.setState({
                      ssoCheckBox: !this.state.ssoCheckBox,
                    })
                  }
                  checked={this.state.ssoCheckBox}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  // label="เปิดประกันสังคมพนง.ทุกคน"
                  label="<span style='padding-left: 10px;'>เปิดประกันสังคมพนักงานทุกคน</span>"
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.onSSOSave.bind(this)}>
              <FontAwesome name="save" /> บันทึก
            </Button>
            <Button
              onClick={() => {
                this.setState({ showSSO: false });
              }}
            >
              <FontAwesome name="close" /> ปิด
            </Button>
            <div className="pull-left" style={{ lineHeight: "36px" }}>
              <ControlLabel> {this.state.statusText} </ControlLabel>
            </div>
          </Modal.Footer>
        </Modal>
        <NotificationSystem ref="notificationSystem" />
      </div>
    );
  }

  renderFooter() {
    let { emType, messages } = this.props;
    let { tableList, table_key_field } = this.state;

    let sumList = this.sumTable(tableList);
    // let startIndex = 6

    let title = messages["Total Daily Wage"];
    if (emType === "monthly") {
      // startIndex = 5

      title = messages["Total Full Time Wage"];
    }
    // let colSpan = startIndex+1
    // hiddenField.map((item,index)=>{
    //   if(item<startIndex)
    //     colSpan--
    //   return item
    // })
    // let hideIndex = startIndex

    if (tableList.length === 0) {
      return "";
    }

    let otherInfoColSpan = this.getTotalColumn(table_key_field.other_info);

    return (
      <tr>
        <th
          colSpan={this.getTotalColumn(table_key_field.employee_info) + 1}
          className="text-right"
        >
          {title}
        </th>
        {table_key_field.income.map((key, index) => {
          return (
            <th
              key={index}
              className={"text-right " + this.getHiddenClass(key)}
            >
              {this.getFooterData(sumList, key)}
            </th>
          );
        })}
        <th className={"text-right " + this.getHiddenClass("total_income")}>
          {this.getFooterData(sumList, "total_income")}
        </th>
        {table_key_field.deduction.map((key, index) => {
          return (
            <th
              key={index}
              className={"text-right " + this.getHiddenClass(key)}
            >
              {this.getFooterData(sumList, key)}
            </th>
          );
        })}
        <th className="text-right">
          {this.getFooterData(sumList, "total_deduction")}
        </th>
        <th className="text-right">
          {this.getFooterData(sumList, "net_income")}
        </th>
        <th className="text-right">
          {this.getFooterData(sumList, "net_payable")}
        </th>
        {otherInfoColSpan === 0 ? (
          ""
        ) : (
          <th
            colSpan={otherInfoColSpan}
            className={"text-right " + (otherInfoColSpan === 0 ? "hide" : "")}
          ></th>
        )}
      </tr>
    );
  }

  renderExportFooter() {
    let { emType, messages } = this.props;
    let { tableList, table_key_field } = this.state;

    let sumList = this.sumTable(tableList);
    // let startIndex = 6

    let title = messages["Total Daily Wage"];
    if (emType === "monthly") {
      // startIndex = 5

      title = messages["Total Full Time Wage"];
    }
    // let colSpan = startIndex+1
    // hiddenField.map((item,index)=>{
    //   if(item<startIndex)
    //     colSpan--
    //   return item
    // })
    // let hideIndex = startIndex

    if (tableList.length === 0) {
      return "";
    }

    let otherInfoColSpan = this.getTotalColumn(table_key_field.other_info);

    return (
      <tr>
        <th
          colSpan={Object.keys(table_key_field.employee_info).length + 1}
          className="text-right"
        >
          {title}
        </th>
        {table_key_field.income.map((key, index) => {
          return this.getHiddenClass(key) === "hide" ? (
            ""
          ) : (
            <th key={index} className={"text-right"}>
              {this.getFooterData(sumList, key)}
            </th>
          );
        })}
        {this.getHiddenClass("total_income") === "hide" ? (
          ""
        ) : (
          <th className={"text-right"}>
            {this.getFooterData(sumList, "total_income")}
          </th>
        )}
        {table_key_field.deduction.map((key, index) => {
          return this.getHiddenClass(key) === "hide" ? (
            ""
          ) : (
            <th key={index} className={"text-right"}>
              {this.getFooterData(sumList, key)}
            </th>
          );
        })}
        <th className="text-right">
          {this.getFooterData(sumList, "total_deduction")}
        </th>
        <th className="text-right">
          {this.getFooterData(sumList, "net_income")}
        </th>
        <th className="text-right">
          {this.getFooterData(sumList, "net_payable")}
        </th>
        {otherInfoColSpan === 0 ? (
          ""
        ) : (
          <th
            colSpan={otherInfoColSpan}
            className={"text-right " + (otherInfoColSpan === 0 ? "hide" : "")}
          ></th>
        )}
      </tr>
    );
  }

  renderToolbarLeft() {
    let { hrConfig, slipPeriod, showPeriod } = this.state;
    let { messages } = this.props;
    return (
      <div>
        <CkSlipPeriod
          show={showPeriod}
          hrConfig={hrConfig}
          slipPeriod={slipPeriod}
          onInitPeriod={this.onInitPeriod.bind(this)}
          onChange={this.onSlipPeriodChange.bind(this)}
        />
        <div>
          <ButtonToolbar>
            <Button
              bsStyle="primary"
              onClick={this.onCreateSlipClick.bind(this)}
            >
              <FontAwesome name="table" /> {messages["Create Slip Table"]}
            </Button>
            <Button
              bsStyle={null}
              className="bg-maroon"
              onClick={this.onSlipPrintAllClick.bind(this)}
            >
              <FontAwesome name="print" /> {messages["Print All Slip"]}
            </Button>
            <Button
              bsStyle={null}
              className="bg-maroon"
              onClick={this.onSlipPrintTableClick.bind(this)}
            >
              <FontAwesome name="print" /> {messages["Print Table"]}
            </Button>
            <Button
              bsStyle={null}
              className="bg-green"
              onClick={this.onSlipExportExcellClick.bind(this)}
            >
              <FontAwesome name="file-excel-o" /> {messages["Export Excel"]}
            </Button>
          </ButtonToolbar>
        </div>
      </div>
    );
  }

  renderToolbarRight() {
    let { messages } = this.props;
    let title = (
      <span>
        <FontAwesome name="cogs" /> {messages["Setting"]}
      </span>
    );
    return (
      <div className="box-tools pull-right">
        <ButtonToolbar>
          <DropdownButton
            id={"dd-settings"}
            bsStyle={"link"}
            title={title}
            pullRight
            className="text-large"
            onSelect={this.onMenuSelect.bind(this)}
          >
            <MenuItem eventKey={4}>
              <FontAwesome name="calendar-plus-o" />
              &nbsp;{"ตั้งค่าประกันสังคม"}
            </MenuItem>
            <MenuItem eventKey={1}>
              <FontAwesome name="calendar-plus-o" />
              &nbsp;{messages["Multipliers"]}
            </MenuItem>
            <MenuItem eventKey={2}>
              <FontAwesome name="calendar-plus-o" />
              &nbsp;{messages["Holiday"]}
            </MenuItem>
            <MenuItem eventKey={3}>
              <FontAwesome name="table" />
              &nbsp;{messages["Display Column"]}
            </MenuItem>
          </DropdownButton>
        </ButtonToolbar>
      </div>
    );
  }

  renderStatusText() {
    let { messages } = this.props;
    let { statusText } = this.state;
    if (statusText !== "") {
      return (
        <Alert
          bsStyle="warning"
          onDismiss={() => {
            this.setState({ statusText: "" });
          }}
        >
          <strong>{messages["Error"]}</strong>{" "}
          <div dangerouslySetInnerHTML={{ __html: statusText }} />
          <div className="box-tools " style={{ height: "30px" }}>
            <ButtonToolbar className="pull-right">
              <Button
                bsStyle="default"
                onClick={() => {
                  this.setState({ statusText: "" });
                }}
              >
                {messages["Close Message"]}
              </Button>
            </ButtonToolbar>
          </div>
        </Alert>
      );
    } else {
      return <div />;
    }
  }

  renderTable() {
    return (
      <div className="table-responsive">
        <table
          className="table table-input-border-none table-bordered-solid table-hover dataTable"
          style={{ minWidth: "1800px", marginBottom: "0" }}
        >
          {this.renderHeader()}
          <tbody>{this.renderTableList()}</tbody>
          <tfoot>{this.renderFooter()}</tfoot>
        </table>
      </div>
    );
  }

  renderExportTable() {
    return (
      <div style={{ display: "none" }}>
        <table
          id={this.refTableId}
          className="table table-input-border-none table-bordered-solid table-hover dataTable"
          style={{ minWidth: "1800px", marginBottom: "0" }}
        >
          {this.renderExportHeader()}
          <tbody>{this.renderExportTableList()}</tbody>
          <tfoot>{this.renderExportFooter()}</tfoot>
        </table>
      </div>
    );
  }

  renderMobileTable() {
    let { tableList } = this.state;
    let fieldMap = {
      title: 2,
      amount: 18,
      sub_title: 0,
      date: 1,
      status: "",
      sub_status: "",
    };
    return (
      <div>
        <ReportMobileTable
          itemlist={tableList}
          fieldMap={fieldMap}
          keyIndex={0}
        />
      </div>
    );
  }

  render() {
    let {
      slipId,
      show,
      showHField,
      periodState,
      tableList,
      editRow,
      hiddenField,
      showHoliday,
      showCfg,
      showAbsenceForm,
      showDeductionForm,
      loading,
    } = this.state;
    let { emType, isMobile, messages } = this.props;
    let boxTitle = messages["Sub Contract Daily Pay Table"];
    if (emType === "monthly") {
      boxTitle = messages["Full Time Pay Table"];
    }
    let employeeId =
      tableList[editRow] !== undefined
        ? tableList[editRow]["employee_id"] !== undefined
          ? tableList[editRow]["employee_id"]
          : ""
        : "";
    return (
      <div>
        <Box loading={loading}>
          <Box.Header>
            <Box.Title>
              <FontAwesome name="history" className="text-blue" />
              &nbsp;{boxTitle} {messages["Date"]} {this.getRangeText()}
            </Box.Title>
            <Box.Tools></Box.Tools>
          </Box.Header>
          <Box.Body>
            <div style={{ marginBottom: "5px" }}>
              {this.renderToolbarRight()}
              {this.renderToolbarLeft()}
            </div>
            {isMobile ? this.renderMobileTable() : this.renderTable()}
            {this.renderExportTable()}
          </Box.Body>
        </Box>
        <SlipEditPopup
          ref="slipEditPopup"
          show={show}
          showStat={true}
          slipId={slipId}
          employeeId={employeeId}
          periodState={periodState}
          pdfTemplate={this.pdfTemplate}
          onEditAbsence={this.onSlipEditAbsence.bind(this)}
          onCloseAbsence={this.onSlipEditAbsenceClose.bind(this)}
          onHide={this.onEditPopup.bind(this)}
        />
        <SlipTableHiddenFieldModal
          show={showHField}
          emType={this.props.emType}
          hiddenField={hiddenField}
          onChange={this.onHiddenFieldChange.bind(this)}
          onHide={() => {
            this.setState({ showHField: false });
          }}
        />
        <HolidayPopup
          ref="holidayPopup"
          show={showHoliday}
          onHide={() => {
            this.setState({ showHoliday: false });
          }}
        />
        <SlipConfigPopup
          ref="slipCfgPopup"
          show={showCfg}
          onHide={() => {
            this.setState({ showCfg: false });
          }}
        />
        <EmployeeAbsenceTablePopup
          ref="absencePopup"
          show={showAbsenceForm}
          onHide={this.onAbsenceClose.bind(this)}
        />
        <EmployeeDeductionTablePopup
          ref="deductionPopup"
          show={showDeductionForm}
          onHide={this.onDeductionClose.bind(this)}
        />
        <AlertPopup />
        <IframeModal ref="iframe" title={"พิมพ์ตาราง"} />
        <ConfirmPopup
          show={this.state.showCreateSlip}
          title={this.state.titleCreateSlip}
          message={this.state.msgCreateSlip}
          onConfirm={this.onCreateSlipConfirm.bind(this)}
          onHide={() => {
            this.setState({
              showCreateSlip: false,
              titleCreateSlip: "",
              msgCreateSlip: "",
            });
          }}
        />
        {this.state.showSSO && this.renderSSOModalConfig()}
      </div>
    );
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
});

export default connect(
  (state) => ({ messages: state.message.view.hr.slip.SlipDailyEmployeeTable }),
  null,
  null,
  { withRef: true },
  mapSizesToProps
)(SlipDailyEmployeeTable);



// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipDailyEmployeeTable.js